'use client';

import { createContext, createElement, useContext } from 'react';

/**
 * Where floating UI (menus, dialogs, tooltips, the Sidenav overlays) is
 * portaled. `null` means `document.body`. Set it when rendering inside a
 * Shadow DOM or an iframe so overlays stay inside it and keep their styles.
 */
const PortalContainerContext = createContext(null);

/** @param {{ container: Element | DocumentFragment | null, children?: import('react').ReactNode }} props */
export function PortalContainerProvider({ container, children }) {
  return createElement(PortalContainerContext.Provider, { value: container }, children);
}

/** @returns {Element | DocumentFragment | null} */
export function usePortalContainer() {
  return useContext(PortalContainerContext);
}
